<template>
    <DCard
        padding
    >
        <DTable
            :items="productClasses"
            :fields="[
                {key: 'id', label: __('products.product_classes.index.table.headers.id'), _classes: 'id'},
                {key: 'name', label: __('products.product_classes.index.table.headers.name'), _classes: 'name'},
                {key: 'active', label: __('products.product_classes.index.table.headers.active'), _classes: 'active'},
                {key: 'actions', label: '', sorter: false, filter: false},
            ]"
            hover
            sorter
        >
            <template #active="{item}">
                <td>
                    <DBadge :color="item.active ? 'success' : 'secondary'">
                        {{ item.active ? __('products.product_classes.index.table.values.active.yes') : __('products.product_classes.index.table.values.active.no') }}
                    </DBadge>
                </td>
            </template>

            <template #actions="{item}">
                <td>
                    <div class="actions">
                        <DButton
                            v-if="!item.active"
                            :id="`activate_${item.id}`"
                            icon="arrow-up-circle-outline"
                            :label="__('products.product_classes.index.table.action.activate')"
                            @click="activateCustomerSegments(item.id)"
                        />
                        <DButton
                            v-if="item.active"
                            :id="`deactive_${item.id}`"
                            icon="arrow-down-circle-outline"
                            :label="__('products.product_classes.index.table.action.deactivate')"
                            @click="deactivateCustomerSegments(item.id)"
                        />
                        <DButton
                            :id="`edit_${item.id}`"
                            icon="pencil"
                            @click="editCustomerSegments(item.id)"
                        />
                        <DButton
                            :id="`btn-delete-${item.id}`"
                            :disabled="item.in_use === true"
                            icon="trash-can-outline"
                            color="danger"
                            @click="destroyCustomerSegments(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('products.product_classes.index.add_button')"
                @click="openCreatePage"
            />
        </DFabs>
        <DModal
            v-model:show="showConfirmationModal"
            :title="__('products.product_classes.index.deleteConfirmation.title')"
            :message="__('products.product_classes.index.deleteConfirmation.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { router } from '@inertiajs/vue3'
import { ref } from 'vue'

defineProps({
    productClasses: {
        type: Array,
        default: () => { return [] }
    }
})
const showConfirmationModal = ref(false)
let deleteCallBack = () => { return {} }

function activateCustomerSegments (id) {
    router.post(route('products.product-classes.activate', id))
}

function deactivateCustomerSegments (id) {
    router.post(route('products.product-classes.deactivate', id))
}

function destroyCustomerSegments (id) {
    deleteCallBack = () => {
        router.delete(route('products.product-classes.destroy', id))
        showConfirmationModal.value = false
    }
    showConfirmationModal.value = true
}

function editCustomerSegments (id) {
    router.get(route('products.product-classes.edit', id))
}

function openCreatePage () {
    router.get(route('products.product-classes.create'))
}
</script>

<style lang="scss" scoped>
.actions {
    display: flex;
    grid-gap: 10px;
    justify-content: flex-end;
}
</style>
